import React from "react";
import ComplianceSection from "../../components/ComplianceSection/ComplianceSection";

const NinCompliance = () => {
  return <ComplianceSection />;
};

export default NinCompliance;
